import React, {Fragment} from "react";
import {connect} from "dva";
import {message, InputNumber, Tabs, Empty, Menu, Dropdown, Carousel, Tag, Spin} from "antd";
import {DownOutlined} from '@ant-design/icons';
import {Scrollbars} from 'react-custom-scrollbars';
import NP from 'number-precision';
import pathToRegexp from 'path-to-regexp'
import {Base64} from 'js-base64';
import classnames from 'classnames';
import GoodsCarousel from './components/goods-carousel';

import {ShopFetch, CartFetch, CouponFetch} from "../../services/service";
import StorageUtil from "../../utils/storage-util";
import CommonUtil from "../../utils/common-util";
import {LocalConst} from "../../utils/constant";
import CheckUtil from "../../utils/check-util";
import RenderUtil from "../../utils/render-util";
import BreadcrumbBlock from "../../components/breadcrumbBlock";
import {PhotoProvider, PhotoView} from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import IMGPlay from '../../assets/images/play.png';
import IMGPause from '../../assets/images/pause.png';
import ImgAdapt from "../../components/img-adapt";
import IMG_Default from "../../assets/images/loading_bg_template.png";
import DataConstant from "../../utils/data-constant";
import {injectIntl} from 'react-intl'
import InitUtil from "../../utils/init-util";
import UrlUtil from "../../utils/url-config";
import CouponDrawer from './components/coupon-drawer';

const {TabPane} = Tabs;

@injectIntl
@connect(state => ({...state.appModel}))
class GoodsDetail extends React.Component {
    constructor(props) {
        super(props);
        const {location: {state}, match: {params}} = props;
        if (state) {
            Object.assign(state, this.formatGoods(state));
        }
        this.allowClientPrice = !StorageUtil.getItem(LocalConst.allowClientPrice);
        this.isLogin = CommonUtil.isLogin();
        this.user = StorageUtil.getItem(LocalConst.mShop_user);
        this.goodsId = +params.id;
        this.productId = params.productId;
        this.companyId = StorageUtil.getItem(LocalConst.companyId);
        this.companyTheme = StorageUtil.getItem(LocalConst.companyTheme);
        // 价格精度
        this.priceScale = StorageUtil.getItem(LocalConst.priceScale);
        this.countScale = StorageUtil.getItem(LocalConst.countScale);
        this.clientShowCubage = StorageUtil.getItem(LocalConst.clientShowCubage);
        this.inputNumberMin = 1;
        switch (+this.countScale) {
            case 1:
                this.inputNumberMin = 0.1;
                break;
            case 2:
                this.inputNumberMin = 0.01;
                break;
        }
        // 库存是否可以超售
        this.enableStockZero = StorageUtil.getItem(LocalConst.enableStockZero);
        //起订量
        this.enableMinCount = StorageUtil.getItem(LocalConst.enableMinCount);
        //限定量
        this.enableMaxCount = StorageUtil.getItem(LocalConst.enableMaxCount);
        // 是否开启了PC显示去配灯按钮
        this.enablePcScene = StorageUtil.getItem(LocalConst.enablePcScene);
        //默认订货单位
        this.orderDefaultUnit = StorageUtil.getItem(LocalConst.orderDefaultUnit); //1:默认按基本单位订货;2:默认按最大辅助单位订货
        this.currencySymbol = StorageUtil.getItem(LocalConst.currencySymbol) || '￥';
        this.carouselRef = React.createRef();
        this.smiRef = React.createRef();

        this.state = {
            goods: state || {},//商品详情
            isLoading: true,
            recommendLoading: true,
            recommendQuery: {
                webApp_: 1,
                showCount: 20,
                company_: this.companyId,
                goods_id_: this.goodsId
            },
            recommendList: [],
            currentProduct: {},
            addProductList: [],
            isShowAddProductList: false,
            isShowVideo: false,
            promotionInfo: {},
            orderPromotion: {},
            specsValue: {},
            specsValueLvl: {},
            total_cubage_: '',
            active: 0,
            pageSize: 0,
            imgList: [],
            productImgList: [],
            goodsImgList: [],

        };
    }

    componentDidMount() {
        this.cartParams = [];
        this.historyListen = this.props.history.listen((location, action) => {
            const pathMatch = pathToRegexp('/goods/detail/:id/:productId?').exec(location.pathname);
            if (pathMatch) {
                this.goodsId = pathMatch && pathMatch[1];
                this.productId = pathMatch && pathMatch[2];
                this.initGoodsDetail();
            }
        });

        // 回到顶部
        document.body.scrollTo(0, 0);
        //监听视频播放状态，获取播放进度时间
        document.querySelector('#jsVideo').addEventListener("timeupdate", () => {
            let timeDisplay;
            //用秒数来显示当前播放进度
            timeDisplay = Math.floor(document.querySelector('#jsVideo').currentTime);
            // timeDisplay = (timeDisplay + 1);
            this.timeDisplay = this._changeTimeBySecond(timeDisplay);
            this.forceUpdate()
        }, false);
        //监听视频是否暂停播放
        document.querySelector('#jsVideo').addEventListener('pause', () => {
            this.setState({
                isShowVideoPauseBtn: false,
                isShowVideoPlayBtn: true
            });
        });
    }

    componentWillUnmount() {
        window.clearInterval(this.interval_);
        this.historyListen();
    }

    initGoodsDetail = () => {
        this.getGoodsById();

        // 推荐商品
        this.getRecommendedGoodsList();

        if (this.isLogin) {
            this.saveGoodsViewLog();
            // 获取优惠券
            this.getCouponList();
        }
    };

    //获取优惠券
    getCouponList = () => {
        let params = {
            showCount: 99999999,
            orderby: 'money_',
            ascending: 'DESC',
            goods_id_: this.goodsId,
        };
        CouponFetch.listCouponActivityByShop(params).then(rs => {
            if (rs.status === 1) {
                let pdList = rs.data.pdList;
                let canReceivedList = [];
                let canUsedList = [];
                pdList.forEach(item => {
                    if (item.validity_type_ === 1) {
                        item.begin_time_ = item.begin_time_.replace(/-/g, '.').substr(0, 11);
                        item.end_time_ = item.end_time_.replace(/-/g, '.').substr(0, 11);
                    }
                    if (item.form_status_ === 100) {
                        if ((item.count_ - item.receive_count_) > 0 && (!item.client_receive_count_ || (item.client_receive_count_ < item.limit_))) {
                            canReceivedList.push(item)
                        }
                        if (item.client_receive_count_ && item.client_used_count_ && (item.client_used_count_ >= item.client_receive_count_)) {
                            canUsedList.push(item)
                        }
                    }
                });
                this.setState({
                    couponList: pdList,
                    couponListInfo: {
                        canReceivedList: canReceivedList,
                        canUsedList: canUsedList
                    }
                })
            }
        })
    };

    //领取优惠券
    receivePress = (item) => {
        const {intl} = this.props;
        let residue_count_ = item.count_ - item.receive_count_;
        let receive_num_ = residue_count_ > item.limit_ ? item.limit_ : residue_count_;
        let params = {
            activity_id_: item.id_,
            receive_num_: receive_num_
        };
        CouponFetch.receiveCoupon(params, (rs) => {
            if (rs.status === 1) {
                const content = intl.formatMessage(
                    {id: 'GXNHQ_Z_Y_', defaultValue: `恭喜您获取${parseInt(receive_num_)}张${item.money_}元${intl.messages[DataConstant.couponType[item.type_]]}`},
                    {
                        num: parseInt(receive_num_),
                        price: item.money_,
                        name: intl.messages[DataConstant.couponType[item.type_]],
                    }
                );
                message.success(content);
                this.getCouponList();
            } else {
                message.info(rs.message, 1);
            }
        })
    };
    // 获取商品详情
    getGoodsById = () => {
        //获取商品详情
        ShopFetch.getGoodsById(this.goodsId, (rs) => {
            if (rs.status === 1) {
                // 经营屏蔽导致商品为空
                if (rs.data === null) {
                    this.setState({
                        isLoading: false,
                        visiblePageNull: true
                    });
                    return;
                }
                console.log('getGoodsById', rs.data);
                if (this.user && rs.data.company_id_ !== this.user.company_id_) {
                    if (!CommonUtil.checkExperience(rs.data.company_id_)) {
                        localStorage.setItem("isExperience", 0);
                    }
                    StorageUtil.delItem(LocalConst.mShop_user);
                }
                StorageUtil.setItem(LocalConst.companyId, rs.data.company_id_);
                rs.data = this.formatGoods(rs.data);
                const imgList = [];
                let currentProduct = {};

                // 将当前默认的单位应用到规格中
                rs.data.productList.forEach(product => {
                    product.unit_id_ = this.currentUnit.unit_id_;
                    product.unit_name_ = this.currentUnit.unit_name_;
                    product.unit_text_ = this.currentUnit.unit_text_;
                    product.number_scale_ = this.currentUnit.scale_;
                });

                rs.data.productList.forEach(product => {
                    product.cart_number_ = 0;
                    product.realPrice = product.client_price_;
                    console.log('product.realPrice==========>', product.realPrice)
                    product.enableStock = product.house_enable_stock_;
                    // product.number_scale_ = 1;
                    // product.unit_text_ = rs.data.unit_name_;
                    if (product.img_) {
                        imgList.push({...product, url_: product.img_});
                    } else {
                        imgList.push({...product, url_: rs.data.main_img_});
                    }
                    if (product.id_ === +this.productId) {
                        currentProduct = product
                    }
                });
                // if (!rs.data.imgList || rs.data.imgList.length === 0) {
                //     rs.data.imgList = imgList.length > 0 ? imgList : [{id_: 0, url_: IMG_Default}]
                // }
                // rs.data.imgList = imgList || [];
                // fix:YSDH-14475
                if (rs.data.is_multi_unit_) {
                    this.maxUnit = {...rs.data.mult_unit_[0]};
                    rs.data.mult_unit_.forEach(unit => {
                        if (unit.scale_ > this.maxUnit.scale_) {
                            Object.assign(this.maxUnit, unit);
                        }
                    });
                }
                this.setState({
                    goods: rs.data,
                    isLoading: false,
                    promotionInfo: {},
                    currentProduct: currentProduct,
                    imgList: imgList || [],
                    productImgList: imgList || [],
                    goodsImgList: rs.data.imgList || [],
                }, () => {
                    const {goods} = this.state;
                    if (this.isLogin && rs.data.putaway_) {
                        this.getPromotionByGoodsId(rs.data);
                        this.getPromotionByCompanyId(rs.data)
                    }
                    if (goods.productList.length === 1 && !goods.is_multi_spec_) {
                        this.defaultSingleSelect();
                    }
                });

            } else {
                // message.info(rs.message);
                this.state({
                    isLoading: false,
                });
            }

        });

    };

    getPromotionByCompanyId = (data) => {
        const companyId = StorageUtil.getItem(LocalConst.companyId);
        const params = {companyId: companyId};
        CartFetch.getPromotionByCompanyId(params, rs => {
            if (rs.status === 1) {
                if (rs.data) {
                    this.setState({
                        orderPromotion: rs.data
                    })
                }
            } else {
                message.info(rs.message);
            }
        });
    };
    //获取推荐商品
    getRecommendedGoodsList = () => {
        const {recommendQuery} = this.state;
        ShopFetch.searchRecommendedGoodsListForShop(recommendQuery, rs => {
            if (rs.status === 1) {
                this.setState({
                    recommendList: rs.data.pdList || [],
                })
            }
        })
    };
    //保存浏览足迹
    saveGoodsViewLog = () => {
        const param = {
            goods_id_: this.goodsId,
            client_id_: this.user.client_id_
        };
        ShopFetch.saveGoodsViewLog({
            jsonStr: JSON.stringify(param)
        }, (rs) => {
            if (!rs.status) {
                console.log(rs.message)
            }
        })
    };
    getPromotionByGoodsId = (goodsData) => {
        const getPromotion = new Promise((resolve, reject) => {
            CartFetch.getPromotionByGoodsId({goodsId: this.goodsId}, (rs) => {
                if (rs.status === 1) {
                    let promotionList = [];
                    rs.data.forEach(item => {
                        goodsData.productList.forEach(product => {
                            if (item.product_id_ === product.id_) {
                                promotionList.push(item);
                                product.promotionType = item.type_;
                            }
                        })
                    });
                    resolve(promotionList)
                } else {
                    reject(rs.message)
                }
            })
        });

        const getPresalePromotion = new Promise((resolve, reject) => {
            CartFetch.getpresalePromotionByGoodsId({goodsId: this.goodsId}, (rs) => {
                if (rs.status === 1) {
                    let promotionList = [];
                    rs.data.forEach(item => {
                        item.type_ = 4;
                        goodsData.productList.forEach(product => {
                            if (item.product_id_ === product.id_) {
                                product.realPrice = item.presale_price_;
                                product.promotionType = item.type_;
                                promotionList.push(item)
                            }
                        })
                    });
                    resolve(promotionList)
                } else {
                    reject(rs.message)
                }
            })
        });
        Promise.all([getPromotion, getPresalePromotion]).then((results) => {
            let promotionArr = [...results[0], ...results[1]];
            let promotionInfo = {};
            promotionArr.forEach(promotion => {
                promotionInfo = ({...promotionInfo, [promotion.product_id_]: {productPromotion: promotion}});
            });
            this.setState({
                promotionInfo: promotionInfo
            }, () => {
                if (!CheckUtil.isEmptyObject(this.state.promotionInfo) && !this.interval_) {
                    this.interval_ = window.setInterval(() => {
                            const {promotionInfo} = this.state;
                            for (let key in promotionInfo) {
                                const item = promotionInfo[key].productPromotion;
                                if (item.remaining_time_ > 0) {
                                    item.remaining_time_ = item.remaining_time_ - 1000;
                                }
                            }
                            this.setState({
                                promotionInfo: promotionInfo
                            })
                        }, 1000
                    );
                }
            });
        }).catch((error) => {
            console.log(error)
        });
    };
    // 格式化商品数据
    formatGoods = (goods) => {
        //处理商品标签信息
        goods.tag_ids_ = (goods.tag_ids_ ? goods.tag_ids_.split(",") : []);
        goods.tag_names_ = (goods.tag_names_ ? goods.tag_names_.split(",") : []);
        goods.tag_colors_ = (goods.tag_colors_ ? goods.tag_colors_.split(",") : []);
        this.currentUnit = {
            unit_id_: +goods.unit_id_,
            unit_name_: goods.unit_name_,
            unit_text_: goods.unit_text_,
            scale_: 1,
            unit_price_key_: 'client_price_'
        };
        let multUnitList = [{...this.currentUnit}];
        multUnitList = multUnitList.concat(CommonUtil.stringToArr(goods.multi_unit_).extend_units_ || []);
        multUnitList.forEach((unit, index) => {
            unit.unit_id_ = +unit.unit_id_;
            unit.scale_ = +unit.scale_;
            if (index === 0) {
                unit.unit_price_key_ = 'unit_price_';
            } else if (index === 1) {
                unit.unit_price_key_ = 'unit2_price_';
            }
        });
        multUnitList = multUnitList.filter(item => item.unit_id_);
        if (goods.is_multi_unit_) {
            // 默认辅助单位选取最大的
            if (this.orderDefaultUnit === 2) {
                for (let i = 0; i < multUnitList.length; i++) {
                    if (multUnitList[i].scale_ > this.currentUnit.scale_) {
                        Object.assign(this.currentUnit, multUnitList[i]);
                    }
                }
            }
            const usableUnitList = CommonUtil.handleMultiUnits(CommonUtil.stringToArr(goods.multi_unit_));
            if (!usableUnitList.length) {
                this.unitList = [{...this.currentUnit}];
            } else {
                this.unitList = [];
                usableUnitList.forEach(unitId => {
                    multUnitList.forEach(unit => {
                        if (unitId === unit.unit_id_) {
                            this.unitList.push(unit);
                        }
                    });
                });
                if (this.unitList.length === 1) {
                    Object.assign(this.currentUnit, {...this.unitList[0]});
                } else {
                    // 销售设置设置为最大辅助单位订货
                    if (this.orderDefaultUnit === 2) {
                        const resultList = this.unitList.filter(unit => unit.unit_id_ === this.currentUnit.unit_id_);
                        if (!resultList.length) {
                            this.unitList.sort((a, b) => (a.scale_ - b.scale_));
                            Object.assign(this.currentUnit, {...this.unitList[1]});
                        }
                    } else { // 销售设置设置为基本单位订货
                        if (CommonUtil.stringToArr(goods.multi_unit_).usable_[0] === 0) { // 可订货单位中没有基本单位,取最小辅助单位
                            this.unitList.sort((a, b) => (a.scale_ - b.scale_));
                            Object.assign(this.currentUnit, {...this.unitList[0]});
                        }
                    }
                }
            }
            goods.mult_unit_ = this.unitList;
        } else {
            goods.mult_unit_ = [{...this.currentUnit}];
        }

        if (goods.is_multi_spec_) {
            goods.spec_setting_ = CommonUtil.stringToObj(goods.spec_setting_);
            goods.spec_setting_.settings_.sort((a, b) => {
                return a.seq_ - b.seq_;
            })
        }

        goods.introduce_ = CommonUtil.stringToArr(goods.introduce_);
        goods.property_custom_json_ = CommonUtil.stringToArr(goods.property_custom_json_);
        // 商品参数
        if (!goods.propList) {
            goods.propList = [];
            goods.property_custom_json_.forEach(item => {
                if (item.is_show_) {
                    goods.propList.push({name_: item.name_, value_: item.value_})
                }
            });
        } else {
            goods.propList = goods.propList.filter(item => {
                return item.id_ && item.is_show_ || !item.id_
            })
        }
        return goods;
    };
    // 单位修改
    changeUnit = (unit) => {
        const {intl} = this.props;
        const {currentProduct, addProductList} = this.state;
        if (Object.keys(currentProduct).length === 0) {
            message.info(intl.messages['QXZGG'] || '请选择规格！');
            return;
        }
        Object.assign(currentProduct, {
            number_scale_: +unit.scale_,
            unit_id_: +unit.unit_id_,
            unit_name_: unit.unit_name_,
            unit_text_: unit.unit_text_ || unit.unit_name_,
            unit_price_key_: unit.unit_price_key_,
        });

        currentProduct.realPrice = CommonUtil.priceScale(NP.times(currentProduct.client_price_, unit.scale_)) || currentProduct[unit.unit_price_key_];
        currentProduct.enableStock = parseInt(NP.divide(currentProduct.house_enable_stock_ || 0, unit.scale_ || 0));
        let min_count_ = currentProduct.min_count_;
        let max_count_ = currentProduct.max_count_;
        if (min_count_) {
            min_count_ = NP.divide(min_count_, currentProduct.number_scale_);
        }
        if (max_count_) {
            max_count_ = NP.divide(max_count_, currentProduct.number_scale_);
        }
        currentProduct.new_min_count_ = min_count_;
        currentProduct.new_max_count_ = max_count_;
        this.setState({
            currentProduct: currentProduct
        }, () => {
            let totalPrice = 0;
            addProductList.forEach(item => {
                item.totalPrice = NP.times(currentProduct[unit.unit_price_key_] || item.realPrice, item.cart_number_);
                totalPrice = NP.plus(item.totalPrice, totalPrice);
            });
            this.setState({
                totalPrice
            })
        })
    };
    // 修改购物车数量
    changeNumber = (num, product) => {
        const {intl} = this.props;
        const {pdList, currentProduct, addProductList, goods, promotionInfo} = this.state;
        if (!this.isLogin) {
            RenderUtil.renderLoginModal.call(this.props.intl);
            return;
        }
        if (Object.keys(currentProduct).length === 0) {
            message.info(intl.messages['QXZGG'] || '请选择规格！');
            return
        }
        const editProduct = product || currentProduct;
        const unit_price_ = editProduct[editProduct.unit_price_key_];

        let realPrice = editProduct.client_price_ || unit_price_;

        if (editProduct.number_scale_ > 1) {
            realPrice = CommonUtil.priceScale(NP.times(editProduct.client_price_, editProduct.number_scale_)) || unit_price_;
        }
        let min_count_ = editProduct.min_count_;
        let max_count_ = editProduct.max_count_;
        if (min_count_) {
            min_count_ = NP.divide(min_count_, editProduct.number_scale_);
        }
        if (max_count_) {
            max_count_ = NP.divide(max_count_, editProduct.number_scale_);
        }
        editProduct.new_min_count_ = min_count_;
        editProduct.new_max_count_ = max_count_;
        const {productPromotion} = promotionInfo[editProduct.id_] || {};
        // 订货限制 house_stock_status_：1 正常  2 预售  3 停售
        // 订货限制设置为预售则前端下单不校验库存信息
        // 订货限制设置为停售则前端下单需校验库存信息
        // 此库存校验规则优先级高于全局的库存限制
        if (goods.house_stock_status_ === 1) { // 正常
            if (editProduct.house_enable_stock_ < num && !this.enableStockZero && editProduct.promotionType !== 4) {
                // 库存不足不允许添加
                editProduct.cart_number_ = editProduct.house_enable_stock_ && editProduct.house_enable_stock_ > 0 ? editProduct.house_enable_stock_ : 0;
                message.destroy();
                message.warn(intl.messages['KuCunBuZu'] || '库存不足');
            } else {
                editProduct.cart_number_ = +num;
            }
        } else if (goods.house_stock_status_ === 2) { // 预售
            editProduct.cart_number_ = +num;
        } else if (goods.house_stock_status_ === 3) { // 停售
            if (editProduct.house_enable_stock_ < num) {
                // 库存不足不允许添加
                editProduct.cart_number_ = editProduct.house_enable_stock_ && editProduct.house_enable_stock_ > 0 ? editProduct.house_enable_stock_ : 0;
                message.destroy();
                message.warn(intl.messages['KuCunBuZu'] || '库存不足');
            } else {
                editProduct.cart_number_ = +num;
            }
        }

        if (editProduct.client_type_min_count_) {
            if (this.enableMinCount && (editProduct.client_type_min_count_ || editProduct.client_type_min_count_ === 0) && editProduct.cart_number_ < editProduct.client_type_min_count_) {
                message.warn(intl.messages['DYQDL'] || '低于起订量');
                editProduct.cart_number_ = editProduct.client_type_min_count_;
                return;
            }
        } else {
            if (this.enableMinCount && (editProduct.min_count_ || editProduct.min_count_ === 0) && editProduct.cart_number_ < min_count_) {
                message.warn(intl.messages['DYQDL'] || '低于起订量');
                editProduct.cart_number_ = editProduct.min_count_;
                return;
            }
        }
        if (this.enableMaxCount && (editProduct.max_count_ || editProduct.max_count_ === 0) && editProduct.cart_number_ > max_count_) {
            message.warn(intl.messages['GYXDL'] || '高于限订量');
            editProduct.cart_number_ = editProduct.max_count_;
            return;
        }

        let usePromotion;
        //基础单位的时候，处理促销
        if (editProduct.unit_id_ === goods.unit_id_ && productPromotion && Object.keys(productPromotion).length) {
            switch (productPromotion.type_) {
                case 1:
                    usePromotion = this.handleGoodsPromotionPresent(editProduct, productPromotion);
                    break;
                case 2:
                case 3:
                    usePromotion = this.handleGoodsPromotionPrice(editProduct, productPromotion);
                    break;
                case 4:
                    usePromotion = productPromotion;
                    break;
            }

        } else {
            if (editProduct.number_scale_ > 1) {
                realPrice = CommonUtil.priceScale(NP.times(currentProduct.client_price_, currentProduct.number_scale_)) || unit_price_;
            } else {
                realPrice = CommonUtil.priceScale(NP.times((currentProduct.client_price_ || unit_price_), unit_price_ ? 1 : currentProduct.number_scale_));
            }
        }
        if (usePromotion) {
            promotionInfo[editProduct.id_].usePromotion = usePromotion;
            switch (usePromotion.type_) {
                case 1:
                    editProduct.realPrice = realPrice;
                    break;
                case 2:
                    editProduct.realPrice = usePromotion.cut_money_ || usePromotion.cuted_price_;
                    break;
                case 3:
                    editProduct.realPrice = NP.times(realPrice, NP.divide((usePromotion.cut_percent_ || usePromotion.cuted_percent_), 100));
                    break;
            }
        } else {
            if (promotionInfo[editProduct.id_]) {
                promotionInfo[editProduct.id_].usePromotion = {};
            }
            editProduct.realPrice = realPrice;
        }
        const index = addProductList.findIndex(item => item.id_ === editProduct.id_);
        if (editProduct.cart_number_ > 0) {
            if (addProductList.length === 0) {
                // editProduct.unit_id_ = this.currentUnit.unit_id_;
                // editProduct.unit_name_ = this.currentUnit.unit_name_;
                // editProduct.unit_text_ = this.currentUnit.unit_text_;
                addProductList.push(editProduct)
            } else {
                if (index > -1) {
                    addProductList.splice(index, 1, editProduct)
                } else {
                    // editProduct.unit_id_ = this.currentUnit.unit_id_;
                    // editProduct.unit_name_ = this.currentUnit.unit_name_;
                    // editProduct.unit_text_ = this.currentUnit.unit_text_;
                    addProductList.push(editProduct)
                }
            }
        } else {
            if (index > -1) {
                addProductList.splice(index, 1)
            }
        }

        let totalPrice = 0;
        let totalNumber = 0;
        let total_weight_ = 0;// 运费计算总重量
        let total_cubage_ = 0;// 运费计算总体积
        addProductList.forEach(item => {
            item.totalPrice = NP.times(item.realPrice, item.cart_number_);
            totalNumber = NP.plus(item.cart_number_, totalNumber);
            totalPrice = NP.plus(item.totalPrice, totalPrice);
            if (item.weight_) {
                total_weight_ = NP.plus(total_weight_, NP.times(NP.times(item.weight_, item.number_scale_), item.cart_number_));
            }
            if (item.cubage_) {
                total_cubage_ = NP.plus(total_cubage_, NP.times(NP.times(item.cubage_, item.number_scale_), item.cart_number_));
            }
        });
        this.setState({
            pdList: pdList,
            currentProduct: editProduct,
            totalNumber: totalNumber,
            totalPrice: totalPrice,
            addProductList: addProductList,
            promotionInfo: promotionInfo,
            total_weight_,
            total_cubage_
        })

    };

    //处理买赠的商品促销，获取满足的item
    handleGoodsPromotionPresent = (product, promotion) => {
        if (!promotion) return;
        const itemList = JSON.parse(JSON.stringify(promotion.item_list_));
        const targetPromotion = itemList.sort((itemA, itemB) => itemB.target_number_ - itemA.target_number_).find(item => product.cart_number_ >= item.target_number_);
        if (!targetPromotion) return;
        const index = promotion.item_list_.findIndex(item => targetPromotion.id_ === item.id_);
        targetPromotion.index = index;
        return targetPromotion;
    };
    //处理直降、打折的商品促销，获取满足的item
    handleGoodsPromotionPrice = (product, promotion) => {
        const itemList = JSON.parse(JSON.stringify(promotion.item_list_));
        let targetPromotion;
        if (promotion.is_stair_) {
            targetPromotion = itemList.sort((itemA, itemB) => itemB.target_number_ - itemA.target_number_).find(item => product.cart_number_ >= item.target_number_);
            if (!targetPromotion) return;
            const index = promotion.item_list_.findIndex(item => targetPromotion.id_ === item.id_);
            targetPromotion.index = index;
        } else {
            targetPromotion = promotion;
            targetPromotion.index = 0;
        }
        return targetPromotion;
    };

    batchModifyCart = () => {
        const {intl} = this.props;
        if (this.cartParams.length) {
            message.destroy();
            message.loading((intl.messages['ZhengZaiChuLi...'] || '正在处理...'));
            CartFetch.batchModify(this.cartParams).then(rs => {
                message.destroy();
                if (rs.status === 1) {
                    message.success((intl.messages['JRGWCCG'] || '加入购物车成功'));
                    this.cartParams = [];
                    InitUtil.getCartNumber();
                    this.getGoodsById();
                    this.setState({
                        addProductList: []
                    })
                } else if (rs.status === 403) {
                    // 403重复提交后重试
                    // setTimeout(this.batchModifyCart, 100);
                    // message.error('操作频繁，正在重新尝试...');
                } else {
                    message.error(rs.message);
                }
            });
        }
    };
    getPrice = () => {
        const {intl} = this.props;
        const {goods, currentProduct, promotionInfo} = this.state;
        if (Object.keys(goods).length) {
            let priceText = '';
            if (this.allowClientPrice && !this.isLogin) {
                priceText = (intl.messages['QDLCKJG'] || '请登录查看价格');
                return priceText
            } else {
                if (currentProduct.id_) {
                    const {productPromotion} = promotionInfo[currentProduct.id_] || {};
                    if (currentProduct.unit_id_ === goods.unit_id_ && productPromotion &&
                        !productPromotion.is_stair_ && (productPromotion.type_ === 2 || productPromotion.type_ === 3)) {
                        switch (productPromotion.type_) {
                            case 2:
                                currentProduct.realPrice = productPromotion.cuted_price_;
                                break;
                            case 3:
                                currentProduct.realPrice = NP.times(currentProduct.client_price_, (productPromotion.cuted_percent_ / 100));
                                break;
                            // no default
                        }
                    }
                    console.log('mult_unit_：', goods.mult_unit_)
                    console.log('unit_id_：', currentProduct.unit_id_)
                    console.log('currentProduct：', currentProduct)
                    if (goods.is_multi_unit_) { // 应用等级价
                        const targetIndex = goods.mult_unit_.findIndex((item) => item.unit_id_ === currentProduct.unit_id_);
                        if (targetIndex === 1 && currentProduct.unit_price_) {
                            console.log('currentProduct.unit_price_：', currentProduct.unit_price_)
                            currentProduct.realPrice = currentProduct.unit_price_
                        } else if (targetIndex === 2 && currentProduct.unit2_price_) {
                            console.log('currentProduct.unit2_price_：', currentProduct.unit2_price_)
                            currentProduct.realPrice = currentProduct.unit2_price_
                        }
                    }
                    console.log('priceText：', `${this.currencySymbol}${CommonUtil.priceScale(currentProduct.realPrice)}`)
                    priceText = `${this.currencySymbol}${CommonUtil.priceScale(currentProduct.realPrice)}`;
                    return priceText;
                }
                if (goods.productList && goods.productList.length > 1) {
                    const priceArr = [];
                    goods.productList.forEach(item => {
                        const productPromotion = promotionInfo[item.id_];
                        const promotion = productPromotion ? productPromotion.productPromotion : {};
                        let tmpPrice = item.client_price_;
                        if (promotion && !promotion.is_stair_) {
                            if (promotion.cuted_price_) {
                                tmpPrice = promotion.cuted_price_
                            }
                            if (promotion.cuted_percent_) {
                                tmpPrice = NP.times(promotion.cuted_percent_ / 100, item.client_price_)
                            }
                        }
                        priceArr.push(tmpPrice)
                    });
                    const minPrice_ = Math.min(...priceArr);
                    const maxPrice_ = Math.max(...priceArr);
                    priceText = maxPrice_ === minPrice_ ? `${this.currencySymbol}${CommonUtil.priceScale(minPrice_)}` : `${this.currencySymbol}${CommonUtil.priceScale(minPrice_)} - ${this.currencySymbol}${CommonUtil.priceScale(maxPrice_)}`;
                    return priceText;
                }
                priceText = `${this.currencySymbol}${CommonUtil.priceScale(goods.client_price_)}`;
            }
            return priceText
        }
        return "";
    };
    selectProduct = (product) => {
        let {goods, imgList} = this.state;
        const productImgList = [];
        const active = imgList.findIndex(item => item.id_ === product.id_) || 0;
        productImgList.push(imgList[active]);
        if (imgList[active]) {
            this.setState({
                productImgList,
            }, () => {
                this.setState({
                    currentProduct: product,
                    active,
                }, () => {
                    this.carouselRef.current.goTo(active);
                    if (this.orderDefaultUnit === 2 && goods.is_multi_unit_) {
                        this.changeUnit(this.maxUnit);
                    } else {
                        this.changeUnit(this.currentUnit);
                    }
                })
            });
        }
    };

    // 单规格商品默认选中
    defaultSingleSelect = () => {
        const {goods} = this.state;
        this.selectProduct(goods.productList[0]);
    };

    // 选取组合规格
    selectSpecs(specLvl, key, v) {
        let {specsValue, specsValueLvl, goods} = this.state;
        let specsArr = [];
        let currentSpec = {};
        let currentSpecIndex = -1;
        // 判断点击规格是否已选
        if (specsValue[key] === v) {
            delete specsValue[key];
        } else {
            specsValue[key] = v;
        }
        // 判断点击规格是否已选
        if (specsValueLvl[specLvl] === v) {
            delete specsValueLvl[specLvl];
        } else {
            specsValueLvl[specLvl] = v;
        }

        // 匹配对应规格
        specsArr = Object.values(specsValue);
        let specsLvlArr = Object.values(specsValueLvl);
        if (specsArr.length === goods.spec_setting_.settings_.length) {
            goods.productList.forEach((product, index) => {
                let hsaProduct = true;
                let format = [product.spec_value_];
                if (product.spec_value2_) {
                    format.push(product.spec_value2_);
                }
                if (product.spec_value3_) {
                    format.push(product.spec_value3_);
                }
                if (product.spec_value4_) {
                    format.push(product.spec_value4_);
                }
                if (product.spec_value5_) {
                    format.push(product.spec_value5_);
                }
                inside1:for (let i = 0, j = specsLvlArr.length; i < j; i++) {
                    if (format[i] != (specsLvlArr[i])) {
                        hsaProduct = false;
                        break inside1;
                    }
                }
                if (!hsaProduct) {
                    hsaProduct = true;
                    format.reverse();
                    inside2:for (let i = 0, j = specsLvlArr.length; i < j; i++) {
                        if (format[i] != (specsLvlArr[i])) {
                            hsaProduct = false;
                            break inside2;
                        }
                    }
                }

                if (hsaProduct) {
                    currentSpec = product;
                    currentSpecIndex = index;
                }
            });
        }

        this.setState({
            specsValue: specsValue,
            specsValueLvl: specsValueLvl,
        });
        this.selectProduct(currentSpec);
    };

    // 判断是否有当前组合规格
    notHaveSpecs(id, v) {
        const {specsValue, goods} = this.state;
        //已选同类型
        if (specsValue[id]) {
            let notSpecs = true;
            let outerSpecs = [];
            // 排除已选的同级选项
            for (let key in specsValue) {
                if (parseInt(key) !== id) {
                    outerSpecs.push(specsValue[key]);
                }
            }
            goods.productList.forEach(product => {
                let format = [product.spec_value_, product.spec_value2_, product.spec_value3_, product.spec_value4_, product.spec_value5_];
                // 规格是否包含已选的同类值
                let hasSameSpecs = true;
                outerSpecs.forEach(spec => {

                    if (!format.includes(spec)) {
                        hasSameSpecs = false;
                    }
                });
                // 规格包含已选值和当前值
                if (hasSameSpecs && format.includes(v)) {
                    notSpecs = false;
                }
            });
            return notSpecs;
        } else {
            let notSpecs = true;
            let specsArr = [];
            for (let key in specsValue) {
                specsArr.push(specsValue[key])
            }
            goods.productList.forEach(product => {
                let format = [product.spec_value_, product.spec_value2_, product.spec_value3_, product.spec_value4_, product.spec_value5_];
                let hasSelectSpecs = true;
                specsArr.forEach(spec => {
                    if (!format.includes(spec)) {
                        hasSelectSpecs = false
                    }
                });
                // 规格包含已选值且包含当前值
                if (hasSelectSpecs && format.includes(v)) {
                    notSpecs = false;
                }
            });
            return notSpecs

        }

    }

    toggleAddressList = () => {
        this.setState({
            isShowAddProductList: !this.state.isShowAddProductList
        })
    };
    //收藏
    addGoodsFavorite = () => {
        const {intl} = this.props;
        if (!this.isLogin) {
            RenderUtil.renderLoginModal.call(intl);
            return;
        }
        const {goods} = this.state;
        const fetchKey = goods.is_favorite_ ? `deleteGoodsFavorite` : `addGoodsFavorite`;
        ShopFetch[fetchKey]({
            company_id_: this.companyId,
            goods_id_: goods.id_
        }, (rs) => {
            if (rs.status === 1) {
                goods.is_favorite_ = !goods.is_favorite_;
                this.setState({
                    goods: goods
                })
            }
        }, (rs) => {
            // Toast.info(rs);
        })

    };
    //---------视频部分---------------
    toPlayVideo = () => {
        this.setState({
            isShowVideo: true
        }, () => {
            this.playVideo();
            const duration = Math.floor(document.querySelector('#jsVideo').duration);
            this.timeResult = this._changeTimeBySecond(duration);
        })
    };
    hideVideoPop = () => {
        this.pauseVideo();
        this.setState({
            isShowVideo: false
        })
    };
    //开始播放视频
    playVideo = () => {
        document.querySelector('#jsVideo').play();
        this.setState({
            isShowVideoPauseBtn: true,
            isShowVideoPlayBtn: false,
        })
    };
    //暂停播放视频
    pauseVideo = () => {
        document.querySelector('#jsVideo').pause();
        this.setState({
            isShowVideoPauseBtn: false,
            isShowVideoPlayBtn: true,
        })
    };
    //处理时间格式补0
    _addZero = (time) => {
        let str = time;
        if (time < 10) {
            str = '0' + time;
        }
        return str;
    };
    //转换时间格式
    _changeTimeBySecond = (second) => {
        let minuteTime = 0;
        let secondTime = 0;
        if (second > 60) {  //如果秒数大于60
            minuteTime = Math.floor(second / 60);
            secondTime = Math.floor(second % 60);
            if (minuteTime >= 60) {  //如果分钟大于60
                minuteTime = Math.floor(minuteTime % 60);
            }
        } else {
            minuteTime = 0;
            if (second === 60) {  //如果秒数等于60
                minuteTime = 1;
                secondTime = 0;
            } else {
                secondTime = second;
            }
        }
        return this._addZero(minuteTime) + ':' + this._addZero(secondTime);
    };
    //---------视频部分---------------
    toDetail = (goods) => {
        const {history} = this.props;
        history.push(`/goods/detail/${goods.id_}`);
    };
    // 加入购物车
    addToCart = () => {
        const {intl} = this.props;
        const {addProductList, currentProduct} = this.state;
        if (!this.isLogin) {
            RenderUtil.renderLoginModal.call(this.props.intl);
            return;
        }
        if (!currentProduct.id_) {
            message.info(intl.messages['QXZGG'] || '请选择规格！');
            return;
        }
        if (addProductList.length === 0 && currentProduct.id_) {
            message.info(intl.messages['SPSLYW'] || '商品数量有误！');
            return;
        }
        const params = [];
        let includePresell = false;
        addProductList.forEach(product => {
            params.push({
                goods_id_: product.goods_id_,
                product_id_: product.id_,
                unit_id_: product.unit_id_,
                number_: product.cart_number_,
            });
            /*  if (product.promotionType === 4) {
                  includePresell = true;
              } else {
                  params.push({
                      goods_id_: product.goods_id_,
                      product_id_: product.id_,
                      unit_id_: product.unit_id_,
                      number_: product.cart_number_,
                  });
              }*/
        });
        /*       if (includePresell) {
                   message.info(intl.messages['YSSPBKJRGW'] || '预售商品不可加入购物车，已为您添加非预售商品！')
               }*/
        params.forEach(param => {
            const oldParam = this.cartParams.findIndex(item => item.product_id_ === param.product_id_);
            if (oldParam > -1) {
                this.cartParams.splice(oldParam, 1, param);
            } else {
                this.cartParams.push(param);
            }
            clearTimeout(this.cartTimer);
            this.cartTimer = setTimeout(this.batchModifyCart, 300);
        });

    };
    //立即购买
    buyNow = () => {
        const {intl} = this.props;
        const {goods, addProductList, promotionInfo, currentProduct, orderPromotion} = this.state;
        if (!this.isLogin) {
            RenderUtil.renderLoginModal.call(intl);
            return;
        }
        if (!currentProduct.id_) {
            message.info(intl.messages['QXZGG'] || '请选择规格！');
            return;
        }
        if (addProductList.length === 0 && currentProduct.id_) {
            message.info(intl.messages['SPSLYW'] || '商品数量有误！');
            return;
        }
        let includePresell = false;
        addProductList.forEach(product => {
            if (product.promotionType === 4) {
                includePresell = true;
            }
        });
        if (includePresell) {
            message.info(intl.messages['YSSPBKLJGM'] || '预售商品不可立即购买，请移除预售商品再重新购买！');
            return;
        }
        const newGoods = JSON.parse(JSON.stringify(goods));
        newGoods.productList = addProductList;
        newGoods.checkPrice = 0;
        newGoods.productList.forEach(product => {
            newGoods.checkPrice = NP.plus(newGoods.checkPrice, NP.times(product.cart_number_, product.client_price_))
        });
        if (Object.keys(orderPromotion).length > 0) {
            const orderPromotion_ = this.handleOrderPromotion(newGoods) || {};
            newGoods.useOrderPromotion = orderPromotion_ && orderPromotion_.useOrderPromotion;
            newGoods.orderPromotionPrice = orderPromotion_ && orderPromotion_.orderPromotionPrice;
        }
        this.props.history.push({
            pathname: '/order/create',
            state: {pdList: [newGoods], promotionInfo, useOrderPromotion: newGoods.useOrderPromotion}
        })
    };
    handleOrderPromotion = (group) => {
        const {orderPromotion} = this.state;
        const totalPrice = group.checkPrice;
        if (!orderPromotion || Object.keys(orderPromotion).length === 0) return;
        const itemList = JSON.parse(JSON.stringify(orderPromotion.item_list_));
        /*倒序查出满足的item*/
        const useOrderPromotion = itemList.sort((itemA, itemB) => itemB.target_money_ - itemA.target_money_).find(item => totalPrice >= item.target_money_);
        if (!useOrderPromotion) return;
        /*正序查出满足item的下标，用于展示标记再购可满足项*/
        const promotionIndex = orderPromotion.item_list_.findIndex((item) => item.id_ === useOrderPromotion.id_);
        useOrderPromotion.index = promotionIndex;
        let orderPromotionPrice = 0;
        if (useOrderPromotion && (useOrderPromotion.type_ === 2 || useOrderPromotion.type_ === 3)) {
            orderPromotionPrice = useOrderPromotion.type_ === 2 ? useOrderPromotion.cut_money_ : NP.minus(totalPrice, NP.times(totalPrice, NP.divide(useOrderPromotion.cut_percent_, 100)))
        }
        return {useOrderPromotion, orderPromotionPrice};
    };

    reserveNow = () => {
        const {intl} = this.props;
        const {goods, addProductList, promotionInfo, currentProduct} = this.state;
        if (Object.keys(currentProduct).length === 0) {
            message.info(intl.messages['QXZGG'] || '请选择规格！');
            return;
        }
        if (Object.keys(currentProduct).length > 0 && addProductList.length === 0) {
            message.info(intl.messages['SPSLYW'] || '商品数量有误！');
            return;
        }
        const product = addProductList.find(item => item.promotionType === 4);
        const {usePromotion} = promotionInfo[product.id_] || {};
        if (product.cart_number_ === 0) {
            message.info(intl.messages['SPSLYW'] || '商品数量有误！');
            return;
        }
        if (usePromotion && (usePromotion.min_count_ || usePromotion.min_count_ === 0) && usePromotion.min_count_ > product.cart_number_) {
            message.info(
                intl.formatMessage({
                    id: 'ShangPin1QiShou'
                }, {num: usePromotion.min_count_}));
            // `商品${usePromotion.min_count_}起售`);
            return;
        }
        if (usePromotion && (usePromotion.max_count_ || usePromotion.max_count_ === 0) && usePromotion.max_count_ < product.cart_number_) {
            message.info(
                intl.formatMessage({
                    id: 'SPDGSLBNCG'
                }, {num: usePromotion.max_count_}));
            // `商品订购数量不能超过${usePromotion.max_count_}`);
            return;
        }
        const newGoods = JSON.parse(JSON.stringify(goods));
        newGoods.productList = addProductList;
        this.props.history.push({
            pathname: '/order/create',
            state: {pdList: [newGoods], promotionInfo, isPresale: true, expect_time_: usePromotion.expect_time_}
        })
    };

    renderPromotionInfo = (promotion) => {
        const {intl} = this.props;
        let renderItem = [];
        switch (promotion.type_) {
            case 1:
                promotion.item_list_.forEach(item => {
                    renderItem.push(
                        <div key={item.id_} className={'promotion-item'}>
                            <span>
                                {
                                    intl.M1JZ1J ?
                                        intl.formatMessage({
                                            id: `M1JZ1J`
                                        }, {
                                            num: item.target_number_,
                                            presentNum: item.present_number_
                                        }) : `满${item.target_number_}件赠${item.present_number_}件`
                                }

                                </span>
                            <span className={'img-box'} role={'none'} onClick={() => this.toGoodsDetail(item)}><ImgAdapt
                                src={item.present_product_img_ || item.present_goods_img_ || IMG_Default}/></span>
                            <span className={'high'}>×{item.present_number_}</span>
                        </div>
                    )
                });
                break;
            case 2:
                if (promotion.is_stair_) {
                    promotion.item_list_.forEach(item => {
                        renderItem.push(
                            <div key={item.id_} className={'promotion-item'}>
                                <span>
                                    {
                                        intl._M1JLXMJ1Y_ ?
                                            intl.formatMessage({
                                                id: `_M1JLXMJ1Y_`
                                            }, {
                                                num: item.target_number_,
                                                price: item.cut_money_
                                            })
                                            :
                                            `【满${item.target_number_}件立享每件${item.cut_money_}元】`
                                    }
                                </span>
                            </div>
                        )
                    });
                } else {
                    renderItem.push(
                        <div className={'promotion-item'} key={promotion.id_}>
                            <span>
                            {
                                intl._DHJJZ1Y_ ?
                                    intl.formatMessage({
                                        id: `_DHJJZ1Y_`
                                    }, {
                                        price: promotion.cuted_price_
                                    })
                                    :
                                    `订货价降至${promotion.cuted_price_}元`
                            }
                            </span>
                        </div>
                    )
                }
                break;
            case 3:
                if (promotion.is_stair_) {
                    promotion.item_list_.forEach(item => {
                        renderItem.push(
                            <div key={item.id_} className={'promotion-item'}>
                                <span>
                                    {
                                        intl._M1JLXMJ1Z_ ?
                                            intl.formatMessage({
                                                id: `_M1JLXMJ1Z_`
                                            }, {
                                                num: item.target_number_,
                                                discount: item.cut_percent_
                                            })
                                            :
                                            `【满${item.target_number_}件立享每件打${item.cut_percent_ / 10}折】`
                                    }
                                </span>
                            </div>
                        )
                    });
                } else {
                    renderItem.push(
                        <div className={'promotion-item'}>
                            <span>
                                {
                                    intl._YDHJD1Z_ ?
                                        intl.formatMessage({
                                            id: `_YDHJD1Z_`
                                        }, {
                                            discount: promotion.cuted_percent_ / 10
                                        })
                                        :
                                        `【原订货价打${promotion.cuted_percent_ / 10}折】`
                                }
                            </span>
                        </div>
                    )
                }
                break;
        }
        return renderItem
    };

    toGoodsList = (promotion) => {
        this.props.history.push({
            pathname: '/goods/list',
            state: {goods_activity_id_: promotion.goods_promotion_activity_id_, from: 'goods'}
        })
    };
    //去配灯
    toLighting = () => {
        const {intl} = this.props;
        const {currentProduct} = this.state;
        if (!currentProduct) {
            message.info('请选择规格！');
            return
        }
        if (!currentProduct.img_) {
            message.info('当前商品未上传规格图，不支持配灯！！');
            return
        }
        let newTab = window.open('about:blank');
        let hostname = window.location.hostname;
        let shopUserInfo = StorageUtil.getItem(LocalConst.mShop_user);
        let getCompany = StorageUtil.getItem(LocalConst.companyId);
        let targetHost = UrlUtil.getLightUrl();// 跳转域名
        const goods_data_ = {
            id_: currentProduct.id_,
            goods_id_: currentProduct.goods_id_,
            img_: currentProduct.img_,
        };
        const auth_code_ = {
            company_id_: getCompany,
            login_: shopUserInfo && shopUserInfo.login_,
            id_: shopUserInfo && shopUserInfo.id_,
            name_: shopUserInfo && shopUserInfo.name_,
            type_: shopUserInfo && shopUserInfo.type_,
            token_: shopUserInfo && shopUserInfo.token_,
        };
        newTab.location.href = targetHost + '?companyId=' + getCompany + '&goods_data_=' + Base64.encode(JSON.stringify(goods_data_)) + '&auth_code_=' + Base64.encode(JSON.stringify(auth_code_));
    };

    toGoodsDetail = (item) => {
        let goodsId = item.present_goods_id_;
        let productId = item.present_product_id_;
        this.props.history.push(`/goods/detail/${goodsId}${productId ? `/${productId}` : ''}`)
    };

    toggleCouponDrawer = () => {
        const {visibleCouponDrawer} = this.state;
        this.setState({
            visibleCouponDrawer: !visibleCouponDrawer
        })
    };

    isDisabled = (product) => {
        const {goods} = this.state;
        let flag = product.house_enable_stock_ <= 0 && !this.enableStockZero;
        if (goods.house_stock_status_ === 2) { // 预售商品
            flag = false;
        }
        return flag;
    };

    carouselChange = (index) => {
        this.setState({
            active: index
        })
    };
    changeActive = (index, flag) => {
        const {imgList = [], goodsImgList} = this.state;
        if (flag) {
            let active = index;
            if (index < 0) {
                active = goodsImgList.length - 1;
            } else if (index > goodsImgList.length - 1) {
                index = 0;
                active = 0;
            }
            this.setState({
                active: active,
                productImgList: goodsImgList,
            }, () => {
                const {active} = this.state;
                this.carouselRef.current.goTo(active);
            });
        } else {
            let active = index;
            if (index < 0) {
                active = goodsImgList.length - 1;
            } else if (index > goodsImgList.length - 1) {
                index = 0;
                active = 0;
            }
            this.setState({
                active: active
            }, () => {
                const {active} = this.state;
                this.carouselRef.current.goTo(active);
            });
        }
    };

    render() {

        const {
            isLoading,
            goods,
            recommendList = [],
            currentProduct = {},
            addProductList,
            isShowAddProductList,
            totalPrice = 0,
            totalNumber = 0,
            isShowVideo,
            isShowVideoPauseBtn,
            isShowVideoPlayBtn,
            promotionInfo,
            imgList = [],
            specsValue = {},
            couponList = [],
            couponListInfo = {},
            visibleCouponDrawer,
            total_cubage_,
            active,
            pageSize,
            goodsImgList,
            productImgList
        } = this.state;
        const {history, intl} = this.props;
        const buyBtnStyle = {
            backgroundColor: CommonUtil.colorRgb('#' + this.companyTheme, 12),
        };
        const overlay = <Menu>
            {
                (goods.mult_unit_ || []).map(unit => {
                    return <Menu.Item
                        onClick={() => this.changeUnit(unit)}
                        key={unit.unit_id_}>
                        {+unit.scale_ === 1 ? unit.unit_name_ : unit.unit_text_}
                    </Menu.Item>
                })
            }
        </Menu>;
        const {productPromotion} = promotionInfo[currentProduct.id_] || {};
        const dateTime = productPromotion ? CommonUtil.timeTranslate(productPromotion.remaining_time_) : undefined;
        const _style = {
            transform: `translate(${-parseInt(active / pageSize) * 100}%,0)`
        };
        return (
            <Spin size="large" tip={intl.messages['NLJZZ'] || '努力加载中'} spinning={isLoading}>
                <section className="bg-white">
                    <BreadcrumbBlock
                        breadSource={[
                            {name: intl.messages['ShouYe'] || '首页'},
                            {
                                name: intl.messages['ShangPinLieBiao'] || '商品列表',
                                click: () => history.push({pathname: '/goods/list', state: {from: 'goods'}})
                            },
                            {name: goods.name_}
                        ]}
                    />

                    <section className="page-wrap">
                        <div className="goods-detail-head">
                            <div className={`goods-detail-carousel`}>
                                <div className={'pos-r'}>
                                    <Carousel
                                        // autoplay
                                        dots={false}
                                        // afterChange={this.carouselChange}
                                        ref={this.carouselRef}
                                    >
                                        {
                                            productImgList.map(item => {
                                                return (
                                                    <PhotoProvider>
                                                        <PhotoView src={item.url_}>
                                                            <div key={item.id_} className={'item'}>
                                                                <ImgAdapt src={item.url_} alt=""/>
                                                            </div>
                                                        </PhotoView>
                                                    </PhotoProvider>
                                                )
                                            })
                                        }
                                    </Carousel>
                                    {
                                        !!goods.video_ &&
                                        <div className={'play-video-btn'} onClick={this.toPlayVideo} role={'none'}>{intl.messages.BoFangShiPin||'播放视频'}</div>
                                    }
                                </div>

                                <div className="carousel-panel">
                                    <div role='none' className={'btn-prev'} onClick={() => this.changeActive(active - 1, true)}>&lt;</div>
                                    <div className={'small-img'} ref={this.smiRef}>
                                        <div className="small-img-wrap" style={_style}>
                                            {
                                                goodsImgList.map((item, index) => {
                                                    return <div key={item.id_}
                                                                role={'none'}
                                                                className={active === index ? 'item active' : 'item'}
                                                                onClick={() => this.changeActive(index, true)}
                                                    >
                                                        <ImgAdapt src={item.url_} alt=""/>
                                                    </div>
                                                })
                                            }
                                        </div>
                                    </div>

                                    <div role={'none'} className={'btn-next'} onClick={() => this.changeActive(active + 1, true)}>&gt;</div>
                                </div>
                            </div>
                            <div className="goods-detail-box">
                                <div className={'name'}>{goods.name_}</div>
                                <div className={'code'}>
                                    {
                                        currentProduct && Object.keys(currentProduct).length ?
                                            <span className={'item'}>{intl.messages['GuiGeBianHao'] || '规格编号'}：{currentProduct.code_}</span> :
                                            <span className={'item'}>{intl.messages['ShangPinBianHao'] || '商品编号'}：{goods.code_}</span>
                                    }

                                    {
                                        (goods.barcode_ || currentProduct.barcode_) &&
                                        <span
                                            className={'item'}>{intl.messages['TiaoXingMa'] || '条形码'}：{currentProduct.barcode_ || goods.barcode_}</span>
                                    }
                                </div>
                                {
                                    goods.selling_point_ &&
                                    <div className={'code'}>
                                        {goods.selling_point_}
                                    </div>
                                }

                                <div className={'coupon-box'}>
                                    <div className={'label'}>{intl.messages['YouHuiQuan'] || '优惠券'}:</div>
                                    <div className={'coupon-list-box'}>
                                        {
                                            couponList.map(item => {
                                                return <div
                                                    key={item.id_}
                                                    className={'coupon-label'}>
                                                        {
                                                            intl.formatMessage({
                                                                id: 'M1J1'
                                                            }, {price: item.target_money_, money: item.money_})
                                                        }
                                                </div>
                                            })
                                        }
                                    </div>
                                    <div className={'more-btn'}
                                         role='none'
                                         onClick={this.toggleCouponDrawer}>
                                        {intl.messages['GengDuo'] || '更多'} <i className='iconfont icon-jump'/>
                                    </div>
                                </div>

                                <div className="price-wrap-row">
                                    {
                                        (currentProduct.market_price_) &&
                                        <div className="price-row">
                                            <div className="title">{intl.messages['LingShouJia'] || '零售价'}</div>
                                            <div className="price"><span
                                                className={'line-through'}>{this.currencySymbol}{CommonUtil.priceScale(currentProduct.market_price_)}</span>
                                            </div>
                                        </div> || null
                                    }
                                    <div className="price-row">
                                        <div className="title">{intl.messages['YouHuiJia'] || '优惠价'}</div>
                                        <div className="price"><span className="hint">{this.getPrice()}</span></div>
                                    </div>
                                    {
                                        productPromotion && productPromotion.type_ === 4 &&
                                        <div className="price-row promotion-row">
                                            <div className="title">{intl.messages['YuShou'] || '预售'}</div>
                                            <div className="price">
                                                <div className={'tag-box'}><Tag
                                                    color="#FF3838">{intl.messages['YuShou'] || '预售'}</Tag></div>
                                                <div className={'info-box'}>
                                                    <p>
                                                        {intl.messages['YuJi'] || '预计'}
                                                        {CommonUtil.formatTime(productPromotion.expect_time_, (`${intl.messages['MMYDDR']} hh: mm` || `MM月DD日 hh: mm`))}{intl.messages['KaiShiFaHuo'] || '开始发货'}</p>
                                                    {
                                                        dateTime &&
                                                        <p className={'high'}>
                                                            {
                                                                intl.messages.JHDJSHS_1T ? (
                                                                    intl.formatMessage({
                                                                        id: 'JHDJSHS_1T',
                                                                    }, {
                                                                        d: dateTime.d,
                                                                        h: dateTime.h,
                                                                        m: dateTime.m,
                                                                        s: dateTime.s
                                                                    })
                                                                ) : (
                                                                    `距活动结束还剩：${dateTime.d}天${dateTime.h}时${dateTime.m}分${dateTime.s}秒`
                                                                )

                                                            }

                                                        </p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {
                                        productPromotion && productPromotion.type_ !== 4 &&
                                        <div className="price-row promotion-row">
                                            <div
                                                className="title">{productPromotion.goods_promotion_activity_title_}</div>
                                            <div className="price">
                                                <div className={'tag-box'}><Tag
                                                    color="#FF3838">{intl.messages[DataConstant.goodsPromotion.type[productPromotion.type_]]}</Tag>
                                                </div>
                                                <div className={'info-box'}>
                                                    <div>{this.renderPromotionInfo(productPromotion)}</div>
                                                    {
                                                        dateTime &&
                                                        <p className={'high'}>
                                                            {
                                                                intl.messages.JHDJSHS_1T ? (
                                                                    intl.formatMessage({
                                                                        id: 'JHDJSHS_1T',
                                                                    }, {
                                                                        d: dateTime.d,
                                                                        h: dateTime.h,
                                                                        m: dateTime.m,
                                                                        s: dateTime.s
                                                                    })
                                                                ) : (
                                                                    `距活动结束还剩：${dateTime.d}天${dateTime.h}时${dateTime.m}分${dateTime.s}秒`
                                                                )

                                                            }
                                                        </p>
                                                    }
                                                </div>
                                                <div className={'more'} role={'none'}
                                                     onClick={() => this.toGoodsList(productPromotion)}>{intl.messages['ChaKanXiangQing'] || '查看详情'} >>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                {
                                    goods.is_multi_spec_ ?
                                        <Fragment>
                                            {
                                                goods.spec_setting_ &&
                                                goods.spec_setting_.settings_.map((spec, index) => {
                                                    return <div className="product-wrap" key={spec.id_}>
                                                        <div className="title">{spec.name_}</div>
                                                        <div className="product-main">
                                                            {
                                                                spec.values_.map((v, specIndex) => {
                                                                    const cls = classnames('product-item', {
                                                                        'active': specsValue[spec.id_] === v
                                                                    });
                                                                    return <button
                                                                        key={`${spec.id_}-${specIndex}`}
                                                                        disabled={this.notHaveSpecs(spec.id_, v)}
                                                                        className={cls}
                                                                        onClick={() => this.selectSpecs(index, spec.id_, v)}>
                                                                        {v}
                                                                    </button>
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                })
                                            }
                                        </Fragment> :
                                        <div className="product-wrap">
                                            <div className="title">{intl.messages['GuiGe'] || '规格'}</div>
                                            <div className="product-main">
                                                <Scrollbars autoHeight autoHeightMax={350}>
                                                    {
                                                        (goods.productList || []).map(product => {
                                                            return (
                                                                <span
                                                                    className={`product-item ${currentProduct.id_ === product.id_ ? 'active' : ''}`}
                                                                    role={'none'} key={product.id_}
                                                                    onClick={() => this.selectProduct(product)}>
                                                            {product.format_}
                                                        </span>
                                                            )
                                                        })
                                                    }

                                                </Scrollbars>
                                            </div>
                                        </div>

                                }


                                <div className="product-info-wrap">

                                    <div className={`cart-list-row ${isShowAddProductList ? 'dis-show' : ''}`}>
                                        <Scrollbars autoHeight autoHeightMax={350}>
                                            {
                                                addProductList.map(item => {
                                                    return (
                                                        <div className="product-info-row" key={item.id_}>
                                                            <div
                                                                className="format-wrap">{item.format_ || (intl.messages['QXZGG'] || '请选择规格')}</div>
                                                            <div
                                                                className="price-wrap">
                                                                {item.realPrice ? `${this.currencySymbol}${CommonUtil.priceScale(item.realPrice)}` : `${this.currencySymbol} - -`}
                                                            </div>
                                                            <div className="unit-wrap">
                                                                {
                                                                    !!goods.is_multi_unit_ ? (
                                                                        <Dropdown overlay={overlay} trigger={['click']}>
                                                                            <div>
                                                                                {
                                                                                    item.unit_name_
                                                                                }
                                                                                <DownOutlined/>
                                                                            </div>
                                                                        </Dropdown>
                                                                    ) : (
                                                                        <span>{item.unit_text_}</span>
                                                                    )
                                                                }
                                                            </div>
                                                            <div
                                                                className="stock-wrap">{CommonUtil.getStockText(item.enableStock || 0, undefined, intl)}</div>
                                                            <div className="number-wrap">
                                                                <InputNumber
                                                                    size="small"
                                                                    value={item.cart_number_}
                                                                    disabled={this.isDisabled(item)}
                                                                    onChange={(num) => this.changeNumber(num, item)}
                                                                    min={this.enableMinCount ? (item.client_type_min_count_ || item.new_min_count_ || item.min_count_ || this.inputNumberMin) : this.inputNumberMin}
                                                                    max={this.enableMaxCount ? (item.new_max_count_ || item.max_count_ || Infinity) : Infinity}
                                                                    precision={+this.countScale}
                                                                    setp={this.inputNumberMin}
                                                                />
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </Scrollbars>
                                    </div>
                                    <div className={`product-num-row ${addProductList.length > 0 ? 'dis-flex' : ''}`}>
                                        <div className="number-total-wrap">{intl.messages['SLHJ'] || '数量合计'}：{totalNumber}</div>
                                        <div
                                            className="price-total-wrap">{intl.messages['JEHJ'] || '金额合计'}：{this.currencySymbol}{CommonUtil.priceScale(totalPrice)}</div>
                                        {
                                            this.clientShowCubage &&
                                            <div style={{marginRight: '60px'}}>{intl.messages['ZongTiJi'] || '体积合计'}：{total_cubage_}(m³)</div> || null
                                        }
                                        <div className="detail-btn" role={'none'}
                                             onClick={this.toggleAddressList}>{intl.messages['ShangPinQingDan'] || '商品清单'}
                                            <i className={`iconfont ${isShowAddProductList ? `icon-open-n-2` : `icon-open-s-2`}`}/>
                                        </div>
                                    </div>
                                    <div className="product-info-row">
                                        <div
                                            className="format-wrap">{currentProduct.format_ || (intl.messages['QXZGG'] || '请选择规格')}</div>
                                        <div
                                            className="price-wrap">{currentProduct.realPrice ? `${this.getPrice()}` : `${this.currencySymbol}- -`}</div>
                                        <div className="unit-wrap">
                                            {
                                                !!goods.is_multi_unit_ ? (
                                                    <Dropdown overlay={overlay} trigger={['click']}>
                                                        <div>{currentProduct.unit_text_ || this.currentUnit.unit_text_ || goods.unit_name_}
                                                            <DownOutlined/></div>
                                                    </Dropdown>
                                                ) : (
                                                    <span>{currentProduct.unit_text_ || goods.unit_name_}</span>
                                                )
                                            }
                                        </div>
                                        <div className="stock-wrap">
                                            {CommonUtil.getStockText((currentProduct.id_ ? currentProduct.enableStock : goods.house_enable_stock_), undefined, intl)}
                                        </div>
                                        <div className="quantity">
                                            {
                                                (currentProduct.client_type_min_count_ || currentProduct.min_count_) && this.enableMinCount ? `${intl.messages['QiDingLiang']}：${currentProduct.client_type_min_count_ || currentProduct.new_min_count_ || currentProduct.min_count_}` : null
                                            }
                                            {(currentProduct.client_type_min_count_ || currentProduct.min_count_) && this.enableMinCount && this.enableMaxCount && currentProduct.max_count_ ? `，` : ``}
                                            {
                                                currentProduct.max_count_ && this.enableMaxCount ? `${intl.messages['XianDingLiang']}：${currentProduct.new_max_count_ || currentProduct.max_count_}` : null
                                            }
                                        </div>
                                        <div className="number-wrap">
                                            <InputNumber
                                                size="small"
                                                min={this.enableMinCount ? (currentProduct.client_type_min_count_ || currentProduct.new_min_count_ || currentProduct.min_count_ || 0) : 0}
                                                max={this.enableMaxCount ? (currentProduct.new_max_count_ || currentProduct.max_count_ || Infinity) : Infinity}
                                                precision={+this.countScale}
                                                setp={this.inputNumberMin}
                                                value={currentProduct.cart_number_ || 0}
                                                disabled={this.isDisabled(currentProduct)}
                                                onChange={(num) => this.changeNumber(num)}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="btn-wrap">
                                    {
                                        goods.putaway_ === 1 ? (
                                            <Fragment>
                                                {
                                                    !!this.enablePcScene &&
                                                    <button className="buy-btn" onClick={this.toLighting}
                                                            style={buyBtnStyle}>{intl.messages['QuPeiDeng'] || '去配灯'}</button>
                                                }
                                                {
                                                    currentProduct.promotionType === 4 ? (
                                                        <button className="buy-btn" onClick={this.reserveNow}
                                                                style={buyBtnStyle}>{intl.messages['LiJiYuDing'] || '立即预定'}</button>
                                                    ) : (
                                                        <Fragment>
                                                            <button className="buy-btn" onClick={this.buyNow}
                                                                    style={buyBtnStyle}>{intl.messages['LiJiGouMai'] || '立即购买'}</button>
                                                            <button className="add-btn"
                                                                    onClick={this.addToCart}>{intl.messages['JRGWC'] || '加入购物车'}</button>
                                                        </Fragment>
                                                    )
                                                }
                                                <div className={`collect-btn ${goods.is_favorite_ ? 'active' : ''}`}
                                                     role={'none'} onClick={this.addGoodsFavorite}><i
                                                    className={`iconfont ${goods.is_favorite_ ? `icon-collect-s` : `icon-collect-n`}`}/>
                                                    {goods.is_favorite_ ? (intl.messages['YiShouCang'] || '已收藏') : (intl.messages['ShouCang'] || '收藏')}
                                                </div>
                                            </Fragment>
                                        ) : (
                                            <button className="disabled-btn"
                                                    disabled={true}>{intl.messages['YiXiaJia'] || '已下架'}</button>
                                        )
                                    }

                                </div>
                            </div>
                        </div>

                        {
                            (recommendList && recommendList.length > 0) &&
                            <Tabs className={'goods-detail-tabs'}>
                                <TabPane tab={intl.messages['XiangGuanTuiJian'] || '相关推荐'} key={1}>
                                    <div className={'recommend-list-box'}>
                                        <Carousel autoplay={false} slidesPerRow={4} slidesToScroll={1}>
                                            {
                                                recommendList.map(goods => {
                                                    return (
                                                        <div key={goods.id_} className="goods-card-cover">
                                                            <div role={'none'} className="goods-list-card"
                                                                 onClick={() => this.toDetail(goods)}>
                                                                <div className="img-box">
                                                                    <ImgAdapt
                                                                        src={goods.main_img_ ? `${goods.main_img_}_200` : IMG_Default}
                                                                        alt=""/>
                                                                </div>
                                                                <div className="goods-info-box">
                                                                    <div className="goods-info-row title-row ellipsis">{goods.name_}</div>
                                                                    <div className="goods-info-row price-row">
                                                                        {
                                                                            this.allowClientPrice && !this.isLogin ? (
                                                                                <p>{intl.messages['DLCKJG'] || '登录查看价格'}</p>
                                                                            ) : (
                                                                                <Fragment>
                                                                                    {
                                                                                        goods.productList.length > 0 && this.props.lang === 'es' &&
                                                                                        <i>{intl.messages['Qi'] || '起'} </i>
                                                                                    }
                                                                                    <i>{this.currencySymbol}</i>
                                                                                    {CommonUtil.priceScale(goods.client_price_)}
                                                                                    {
                                                                                        goods.productList.length > 0 && this.props.lang !== 'es' &&
                                                                                        <i>{intl.messages['Qi'] || '起'}</i>
                                                                                    }
                                                                                    {
                                                                                        (goods.market_price_ || goods.market_price_ === 0) &&
                                                                                        <span>{this.currencySymbol}{CommonUtil.priceScale(goods.market_price_)}</span>
                                                                                    }
                                                                                </Fragment>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </Carousel>
                                    </div>

                                </TabPane>
                            </Tabs>
                        }


                        <Tabs className={'goods-detail-tabs'}>
                            <TabPane tab={intl.messages['TuWenXiangQing'] || '图文详情'} key={1}>
                                {
                                    (goods.explain_ || (goods.introduce_ || []).length > 0) ?
                                        <div className={'goods-detail-introduce'}>
                                            <div dangerouslySetInnerHTML={{__html: goods.explain_}}/>
                                            {
                                                (goods.introduce_ || []).map((url, index) => {
                                                    return (
                                                        <PhotoProvider>
                                                            <PhotoView src={url}>
                                                                <div key={index}><img src={url} alt={url} key={url}/></div>
                                                            </PhotoView>
                                                        </PhotoProvider>
                                                    )
                                                })
                                            }
                                        </div> :
                                        <Empty/>
                                }

                            </TabPane>
                            <TabPane tab={intl.messages['ShangPinCanShu'] || '商品参数'} key={2}>
                                {
                                    (goods.propList || []).length > 0 ?
                                        <div className="goods-detail-property">
                                            {
                                                (goods.propList || []).map((item, index) => {
                                                    let name = item.name_;
                                                    switch (name) {
                                                        case '商品编号':
                                                            name = intl.messages['ShangPinBianHao'];
                                                            break;
                                                        case '分类':
                                                            name = intl.messages['FenLei'];
                                                            break;
                                                        case '品牌':
                                                            name = intl.messages['PinPai'];
                                                            break;
                                                    }
                                                    return <div key={index} className={'item'}>
                                                        {name}：{item.value_}
                                                    </div>
                                                })
                                            }
                                        </div> :
                                        <Empty/>
                                }


                            </TabPane>
                        </Tabs>
                    </section>

                    <div className={isShowVideo ? 'dis-show' : 'dis-hide'}>
                        <div className="video-pop-box">
                            {/*eslint-disable-next-line jsx-a11y/media-has-caption*/}
                            <video src={goods.video_} id="jsVideo" width="600px" height="600px"/>
                            <div className="time-display-box">
                                {this.timeDisplay}/{this.timeResult}
                            </div>
                            {
                                isShowVideoPlayBtn &&
                                <div className="video-play-box" role={'none'} onClick={this.playVideo}><img
                                    src={IMGPlay} alt=""/></div>
                            }
                            {
                                isShowVideoPauseBtn &&
                                <div className="video-pause-box" role={'none'} onClick={this.pauseVideo}><img
                                    src={IMGPause} alt=""/></div>
                            }
                            <div className="video-close"><i className="iconfont icon-cancel" role={'none'}
                                                            onClick={this.hideVideoPop}/></div>
                        </div>
                        <div className="mask mask-show" role={'none'} onClick={this.hideVideoPop}/>
                    </div>
                    {/*优惠券*/}
                    <CouponDrawer
                        visible={visibleCouponDrawer}
                        data={couponListInfo}
                        toggle={this.toggleCouponDrawer}
                        receivePress={this.receivePress}
                    />

                </section>
            </Spin>
        )
    }
}

export default GoodsDetail;

